import * as statistics from '../actions/resident.statistics';
import {ResidentStatistics} from '../entities/resident.statistics';

export interface State {
	statistics?: ResidentStatistics;
}

export const initialState: State = {};

export function reducer(state = initialState, action: statistics.Actions): State {
	switch (action.type) {
		case statistics.SET_STATISTICS:
			return {
				...state,
				statistics: action.payload.data
			};
		default:
			return state;
	}
}

export const getResidents = (state: State) => state.statistics;
